import { useState, useEffect } from "react";
import { StaffMember } from "src/shared/services/interfacev2";
import { getStaff } from "src/shared/services/servicesv2";

export const useStaff = () => {
  const [staffList, setStaffList] = useState<StaffMember[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const getStaffList = async () => {
    try {
      setLoading(true);
      const response = await getStaff();
      //  api.get("/app/pos/v2/staff?is_deleted=false");
      setStaffList(response.data.result || []);
    } catch (error) {
      console.error("API Error:", error);
      setError("Failed to fetch staff list");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getStaffList();
  }, []);

  return { staffList, loading, error, refetch: getStaffList };
};
